import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import IPManagementFormComponent from './IPManagementFormComponent';

import { loadIPList, onSubmit } from './actionCreators';

import form from './constants';

const IPManagementFormContainer = (props) => {
  const { onLoad, initialValues, onSubmit, existingIpRanges } = props;

  useEffect(() => {
    onLoad && onLoad();
  }, []);

  return (
    <IPManagementFormComponent
      form={form}
      initialValues={initialValues}
      onSubmit={onSubmit}
      existingIpRanges={existingIpRanges}
    />
  );
};

IPManagementFormContainer.propTypes = {
  onLoad: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  existingIpRanges: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = (state) => {
  const defaultValues = {
    permissionToEnter: false,
  };
  const listOfIps = get(state, 'ipManagement', {});
  return {
    initialValues: defaultValues,
    existingIpRanges: Object.values(listOfIps),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => loadIPList(dispatch),
  onSubmit: (data) => onSubmit(dispatch, data),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IPManagementFormContainer);
